<template>
<div v-if="viewType === 'SETTING'">
  <div class="title-bar title-h4">상세목록 표시 설정</div>
  <el-form :model="detailInfo" ref="detailInfoForm" label-width="120px" label-position="top">
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item prop="flag">
          <span slot="label">상세목록 포함 여부</span>
          <el-select v-model="detailInfo.flag" style="width: 100%;">
            <el-option v-for="item in defaultSetList.flag" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item prop="sort">
          <span slot="label">상세목록 범위</span>
          <el-select :disabled="detailInfo.flag === 'N'" v-model="detailInfo.sort" style="width: 100%;">
            <el-option v-for="item in defaultSetList.sort" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</div>
<div v-else-if="viewType === 'INFO'" class="wrapper">
  <el-form-item label="상세목록 표시">{{ optionInfo.flag }}</el-form-item>
  <el-form-item label="상세목록 범위">{{ isNil(optionInfo.sort) ? '-' : optionInfo.sort }}</el-form-item>
</div>
<div v-else class="wrapper">
  <el-form-item label="상세목록 표시">{{ previewOptionInfo.flag }}</el-form-item>
  <el-form-item label="상세목록 범위">{{ isNil(previewOptionInfo.sort) ? '-' : previewOptionInfo.sort }}</el-form-item>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';

export default {
  name: 'WDetailInfoComponent',
  props: {
    defaultValue: {
      type: Object,
    },
    defaultSetList: {
      type: Object,
      default: () => {},
    },
    viewType: {
      type: String,
      default: () => 'SETTING',
    },
    optionInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      detailInfo: {},
      previewOptionInfo: {},
    };
  },
  watch: {
    defaultValue: {
      handler() {
        this.initData();
      },
      immediate: true,
    },
  },
  methods: {
    isNil,
    initData() {
      this.$nextTick(() => {
        if (!isNil(this.defaultValue)) {
          this.detailInfo = {
            flag: this.defaultValue.flag,
            sort: this.defaultValue.flag === 'Y' ? this.defaultValue.sort : this.defaultSetList.sort[0].value,
          };
        }
      });
    },
    getData() {
      const data = {
        flag: this.detailInfo.flag,
      };
      if (data.flag === 'Y') {
        data.sort = this.detailInfo.sort;
      }
      return {
        DETAIL_INFO: data,
      };
    },
    getDetailData() {
      const data = {
        flag: find(this.defaultSetList.flag, ['value', this.detailInfo.flag]).label,
      };
      if (this.detailInfo.flag === 'Y') {
        data.sort = this.getTopnData(this.detailInfo.sort);
      }
      return {
        DETAIL_INFO: data,
      };
    },
    getTopnData(sort) {
      const index = findIndex(this.defaultSetList.sort, ['value', sort]);
      return this.defaultSetList.sort[index].label;
    },
    setOptionInfo(defaultValue) {
      this.$nextTick(() => {
        this.detailInfo = {
          flag: defaultValue.flag,
        };
        if (defaultValue.flag === 'Y') {
          this.detailInfo.sort = defaultValue.sort;
        }
        this.previewOptionInfo = this.getDetailData().DETAIL_INFO;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/attr/DetailInfoComponent.vue